import { z } from 'zod';
import { personName } from '../_shared/person-name.js';
export const insurancePassengerSchema = z.object({
    firstName: personName(),
    lastName: personName(),
    birthDate: z.string().min(1),
    gender: z.enum(['MALE', 'FEMALE']),
});
export const calculateInsuranceSchema = z.object({
    arrivalAirportCode: z.string().min(1),
    departureAirportCode: z.string().min(1),
    departureDate: z.string().min(1),
    passengers: z.array(insurancePassengerSchema),
    returnDate: z.string().min(1),
    totalFlightPrice: z.number(),
    tripType: z.string().optional(),
});
